<template>
  <div class="el-row">
    <div class="col-6">
      <div class="info">
        <div class="success"><i class="el-icon el-icon-circle-check"></i> 恭喜您，注册成功！</div>
        <div class="txt desc">请牢记您的账号和密码！</div>
        <div class="txt">
          <el-button type="primary" @click="gotoLogin()">立即登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    gotoLogin() {
      this.$router.push("/login")
    },
  },
}
</script>

<style scoped>
.info {
  margin: auto;
  width: 400px;
  min-height: 400px;
}
.success {
  text-align: center;
  font-size: 36px;
  color: #52c011;
  margin: 30px 0;
}
.txt {
  margin: 20px 0 0 60px;
}
.desc {
}
</style>
